export const BAR_CHART_LABEL_TYPE = {
  X_AXIS: {
    BREAK_WORD: 1,
  }
}
